module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("\r\n")
    ; 
    var ls = require('ListService').default;
    var cnst = require('Constants').default;

    ; __append("\r\n\r\n")
    ;  if (ls.docType === cnst.DOC_TYPE_FORM) { 
    const isMandatory = gridData[selectedRowId].attributes.isMandatory;
    
    ; __append("\r\n    <div class=\"prop-header\"><span class=\"prop-label\">Mandatory</span></div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-8 prop-sublabel form-group-flex\">\r\n            <input type=\"checkbox\" name=\"isMandatory\" ")
    ; __append(escapeFn( isMandatory? 'checked': '' ))
    ; __append(" class=\"form-radio-group\"> \r\n            <label class=\"form-group-label\">Mandatory Answer</label> \r\n        </div>\r\n        <div class=\"col-md-4 nopadding\" style=\"text-align: right;\"> \r\n            <button id=\"mandatoryState\" class=\"btn btn-default hvr-glow button-selector\">...</button>\r\n        </div>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12 nopadding-r\">\r\n            <input type=\"text\" name=\"obligatoryMessage\" data-attr=\"obligatoryMessage\" class=\"")
    ; __append(escapeFn( (isMandatory && gridData[selectedRowId].attributes.obligatoryMessage !== '') ? 'translatable' : ''))
    ; __append("\" value=\"")
    ; __append(escapeFn( gridData[selectedRowId].attributes.obligatoryMessage ))
    ; __append("\" />\r\n        </div>\r\n    </div>\r\n")
    ;  } 
  }
  return __output;

}